module.exports = __webpack_public_path__ + "img/stunning-views2.3b8c9ae8.webp";